const getStyle = (element, prop) =>
    parseInt(
        window.getComputedStyle(element)
            .getPropertyValue(prop))

const getPseudoStyle = (element, prop) =>
    parseInt(
        window.getComputedStyle(element, ':before')
            .getPropertyValue(prop))

// Linear interpolation
const lerp = (a, b, n) => (1 - n) * a + n * b

export {
    getStyle,
    getPseudoStyle,
    lerp,
}